/* GENERATED by scripts/gen-data.mjs — chapter "x-curriculum" (from s2.js + s3.js).
 * Structure only: every string is an i18n key resolved from
 * src/i18n/locales/<lang>/. Edit the content in the artifact and re-run
 * npm run extract, do not hand-edit here. */

import type { NodeDef } from '../../types';

export const N_X_CURRICULUM: NodeDef = {
  "id": "x-curriculum",
  "tagKey": "path:x-curriculum.tag",
  "x": 96,
  "y": 180,
  "w": 176,
  "h": 88,
  "titleKey": "path:x-curriculum.title",
  "subKey": "path:x-curriculum.sub",
  "blocks": [
    {
      "id": "x-curriculum.b1",
      "kind": "explain",
      "xp": 15,
      "titleKey": "path:x-curriculum.b1.title",
      "bodyKey": "path:x-curriculum.b1.body",
      "flowKey": "path:x-curriculum.b1.flow",
      "read": [
        "curri",
        "kt"
      ]
    },
    {
      "id": "x-curriculum.b2",
      "kind": "math",
      "xp": 25,
      "titleKey": "path:x-curriculum.b2.title",
      "math": {
        "exprKey": "path:x-curriculum.b2.math.expr",
        "readKey": "path:x-curriculum.b2.math.read",
        "useKey": "path:x-curriculum.b2.math.use",
        "ref": "spaced",
        "ref2": "hlr"
      }
    },
    {
      "id": "x-curriculum.b3",
      "kind": "check",
      "xp": 30,
      "titleKey": "path:x-curriculum.b3.title",
      "ex": {
        "type": "choice",
        "options": [
          {
            "tKey": "path:x-curriculum.b3.ex.options.0.t",
            "ok": true,
            "fbKey": "path:x-curriculum.b3.ex.options.0.fb"
          },
          {
            "tKey": "path:x-curriculum.b3.ex.options.1.t",
            "ok": false,
            "fbKey": "path:x-curriculum.b3.ex.options.1.fb"
          },
          {
            "tKey": "path:x-curriculum.b3.ex.options.2.t",
            "ok": false,
            "fbKey": "path:x-curriculum.b3.ex.options.2.fb"
          }
        ]
      }
    }
  ],
  "extra": true,
  "parent": "what-ai-is"
};
